/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-empty */
import { AxiosResponse } from 'axios'
import { useState } from 'react'

export const useMutation = <BodyGeneric, ResponseGeneric>(
  fetcher: (
    body: BodyGeneric,
  ) => Promise<AxiosResponse<ResponseGeneric, unknown>>,
) => {
  const [mutating, setMutating] = useState(false)

  const mutate = (body: BodyGeneric) => {
    setMutating(true)
    return fetcher(body)
      .then(data => {
        return Promise.resolve(data)
      })
      .catch((error: any) => {
        return Promise.reject(error)
      })
      .finally(() => {
        setMutating(false)
      })
  }

  return {
    mutate,
    mutating,
  }
}
